import HORUS_SCHEDULER from "./Scheduler.json";
import HAMADA_APES from "./HamadaApes.json";

export const HORUS_SCHEDULER_CONTRACT_ADDRESS = {
  BASE: {
    TESTNET: "0x90cbD03e594ab4E0D8aDBf56be68CAD5ccc86CFF",
    MAINNET: "",
  },
};

export const HORUS_SCHEDULER_ABI = HORUS_SCHEDULER.abi;
export const HAMADA_APES_ABI = HAMADA_APES.abi;
